import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

const muiPaginationStyles: Components<Omit<Theme, 'components'>> = {
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        color: 'var(--primary)',
        '&.Mui-selected': {
          '@media (max-width: 1715px)': {
            height: '28px !important'
          }
        }
      },
      text: {
        color: 'var(--primary)',
        fontSize: '15px',
        fontWeight: '500',
        '@media (max-width: 1715px)': {
          fontSize: '12px !important'
        }
      }
    }
  }
};

export default muiPaginationStyles;
